import {
  _FastDuration___get_seconds__impl__4kvvav8z12ktetqvv0 as _FastDuration___get_seconds__impl__4kvvav,
  get_CoreTime23yr4od90u6o9 as get_CoreTime,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  _FastDuration___get_nanoseconds__impl__pxizcbxg17giquiyw7 as _FastDuration___get_nanoseconds__impl__pxizcb,
  _FastDuration___get_microseconds__impl__o4j93h1wqr6h398tbzx as _FastDuration___get_microseconds__impl__o4j93h,
  get_slowaqovrrnrezzv as get_slow,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  Companion_instance3esksx1cataey as Companion_instance,
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance,
  DateTime__minus_impl_10njw82typsv56yegk5 as DateTime__minus_impl_10njw8,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2au1ep9vhcato as equals,
  Duration__compareTo_impl_pchp0f1g201z2whmah8 as Duration__compareTo_impl_pchp0f,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class PerformanceCounter {
  constructor() {
    PerformanceCounter_instance = this;
    this.ie5_1 = nowMillis(this);
  }
  je5() {
    return _FastDuration___get_nanoseconds__impl__pxizcb(ellapsed(this));
  }
  ke5() {
    return _FastDuration___get_microseconds__impl__o4j93h(ellapsed(this));
  }
  le5() {
    return get_slow(ellapsed(this));
  }
  me5() {
    return ellapsed(this);
  }
}
class Stopwatch {
  constructor(nanosecondProvider) {
    var tmp;
    if (nanosecondProvider === VOID) {
      tmp = Stopwatch$_init_$lambda_lg3mf2;
    } else {
      tmp = nanosecondProvider;
    }
    nanosecondProvider = tmp;
    this.ne5_1 = nanosecondProvider;
    this.oe5_1 = false;
    this.pe5_1 = 0.0;
  }
  qe5() {
    return this.oe5_1 ? _get_currentNano__jndyu4(this) - this.pe5_1 : this.pe5_1;
  }
  re5() {
    return get_fastNanoseconds(this.qe5());
  }
}
class IntTimedCache {
  constructor(ttl, timeProvider, gen) {
    timeProvider = timeProvider === VOID ? Companion_instance : timeProvider;
    this.se5_1 = ttl;
    this.te5_1 = timeProvider;
    this.ue5_1 = gen;
    this.ve5_1 = Companion_getInstance().t9v_1;
    this.we5_1 = 0;
  }
  yq(obj, property) {
    // Inline function 'korlibs.time.IntTimedCache.get' call
    var now = this.te5_1.x9v();
    if (equals(this.ve5_1, Companion_getInstance().t9v_1) || Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8(now, this.ve5_1), this.se5_1) >= 0) {
      this.ve5_1 = now;
      this.we5_1 = this.ue5_1();
    }
    return this.we5_1;
  }
}
//endregion
function _Frequency___init__impl__upasnx(hertz) {
  return hertz;
}
function _Frequency___get_hertz__impl__9m7k6x($this) {
  return $this;
}
function toFrequency(_this__u8e3s4) {
  return get_timesPerSecond(_this__u8e3s4);
}
function get_timesPerSecond(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(1.0 / _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4));
}
var KlockLocale_default;
function nowMillis($this) {
  return get_CoreTime().h9w();
}
function ellapsed($this) {
  return get_fastMilliseconds(nowMillis($this) - $this.ie5_1);
}
var PerformanceCounter_instance;
function PerformanceCounter_getInstance() {
  if (PerformanceCounter_instance === VOID)
    new PerformanceCounter();
  return PerformanceCounter_instance;
}
function _get_currentNano__jndyu4($this) {
  return $this.ne5_1();
}
function Stopwatch$_init_$lambda_lg3mf2() {
  return PerformanceCounter_getInstance().je5();
}
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
initMetadataForObject(PerformanceCounter, 'PerformanceCounter');
initMetadataForClass(Stopwatch, 'Stopwatch', Stopwatch);
initMetadataForClass(IntTimedCache, 'IntTimedCache');
//endregion
//region block: init
KlockLocale_default = null;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  _Frequency___get_hertz__impl__9m7k6x as _Frequency___get_hertz__impl__9m7k6x3nl1kcmlovnv7,
  PerformanceCounter_getInstance as PerformanceCounter_getInstance1nd7bgkclrcrv,
  IntTimedCache as IntTimedCache39ymx9abjz88x,
  Stopwatch as Stopwatch1guqi4xl0rpfb,
  toFrequency as toFrequency3flbtmp5xney7,
};
//endregion
